import React, { useState, useEffect } from 'react'
import { Card, Row, Col, Typography, Select, Spin, Divider, Tabs, Result } from 'antd'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useGetDashboardData } from 'src/cms/hooks/Individual/useGetDashboardData'
import { FaCheckSquare, FaChild, FaFileAlt, FaFileArchive, FaPersonBooth } from 'react-icons/fa'
import { key } from 'src/app/modules/siteSettings'
import { IoPerson, IoPersonOutline } from 'react-icons/io5'
import { MdCancel, MdCorporateFare, MdGroup } from 'react-icons/md'
import { BiChild } from 'react-icons/bi'
import { AiOutlineFileDone } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { normalizeTitle } from 'src/app/modules/formGenerator/CustomObjectFieldTemplate'

const CardComponent = () => {
  const { data: DashboardData, isLoading } = useGetDashboardData('NewCIFNewAccount')
  const roleName = useSelector((state: any) => state.auth?.rolePermissions?.name)
  const module = useSelector((state: any) => state.auth?.module)
  const reportAccess = module?.moduleData?.some((item: any) => item?.alias?.includes('/report'))

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh', // Adjust as needed
          width: '100%',
        }}
      >
        <Spin tip='Loading...' size='large' fullscreen />
      </div>
    )
  }
  if (!roleName) {
    return (
      <Result
        status="warning"
        title="There are some problems with your operation."
      />
    )
  }
  const colors = ['card-grey', 'card-blue', 'card-purple', 'card-light-green']
  const routeMap: any = {
    "kyc-update": "/kyc-account-update",
    "old-kyc-update": "/old-kyc-account-update",
    "new-cif-new-account-personal": "/new-cif-new-account",
  };

  const statusCards: any = [
    { label: "Branch Pending", key: "case-init" },
    { label: "Central User Pending", key: "central-review" },
    { label: "Completed", key: "completed" },
    { label: "Total", key: "total" },
  ];

  return (
    <div className='mt-4'>
      {reportAccess &&
        <section className='mb-4'>
          <h3 className='title'>Branch Details</h3>
          <Divider className="m-0 mb-2" style={{ border: "1px solid rgb(5, 5, 5, 0.1)" }} />
          <div className='row'>
            <div className='col-lg-3 col-md-6 my-2'>
              <Link to={roleName?.toLowerCase()?.includes('ro') ? '/quick-account-opening' : '/account-opening-status'}>
                <a className={`quick-action-card card-amber`}>
                  <div className='card-body'>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                      <div className='action-icon'>
                        <FaFileAlt size={24} />
                      </div>
                      <h3 className='inboxCount'>
                        {Number(DashboardData?.data?.total_count) || 0}
                      </h3>
                    </div>
                    <h5 className='fw-semibold mb-1'>Total Cases</h5>
                  </div>
                </a>
              </Link>
            </div>
            <div className='col-lg-3 col-md-6 my-2'>
              <Link
                to={{
                  pathname: roleName?.toLowerCase()?.includes('ro') ? '/quick-account-opening' : '/new-cif-new-account',
                  state: roleName.toLowerCase()?.includes('ro') ? '/completedAccount' : {
                    openedTab: 'completedIndividual',
                    selectedTabStatus: 'case-init'
                  },
                }}
              >
                <a className='quick-action-card card-green'>
                  <div className='card-body'>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                      <div className='action-icon'>
                        <AiOutlineFileDone size={24} />
                      </div>
                      <h3 className='inboxCount'>
                        {Number(DashboardData?.data?.total_completed) || 0}
                      </h3>
                    </div>
                    <h5 className='fw-semibold mb-1'>Completed</h5>
                  </div>
                </a>
              </Link>
            </div>

          </div>
        </section>}


      {Object.entries(DashboardData?.data?.dashboard ?? {}).map(
        ([workflowKey, workflowValue]: any, index: number) => {
          return (
            <section key={workflowKey} className="mb-4">
              <h3 className="title">{normalizeTitle(workflowKey)}</h3>
              <Divider className="m-0 mb-2" style={{ border: "1px solid rgb(5, 5, 5, 0.1)" }} />

              <div className="row">
                {statusCards
                  .filter(({ key }: any) =>
                    key?.includes('case-init') || key?.includes('central-review')
                      ? Boolean(workflowValue?.All?.[key])
                      : Boolean(workflowValue?.[key])
                  )
                  .map(({ label, key }: any, number: any) => (
                    <div key={key} className="col-lg-3 col-md-6 my-2">
                      <Link to={{
                        pathname: routeMap[workflowKey] || "/",

                        state: {
                          openedTab: workflowKey?.includes('kyc') ? key?.includes('completed') ? 'completeKYC' : 'pendingKyc' : workflowKey?.includes('personal') ? key?.includes('completed') ? 'completedIndividual' : 'individualJointMinor' : 'individualJointMinor',
                          selectedTabStatus: key?.includes('central-review') ? 'central-review' : 'case-init'
                        }

                      }}>
                        <div className={`quick-action-card ${colors[number]}`}>
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div className="action-icon">
                                <IoPerson size={24} />
                              </div>
                              <h3 className="inboxCount">
                                {key?.includes('case-init') || key?.includes('central-review')
                                  ? workflowValue?.All?.[key] ?? 0
                                  : workflowValue?.[key] ?? 0}
                              </h3>
                            </div>
                            <h5 className="fw-semibold mb-1">{label}</h5>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
              </div>
            </section>
          );
        }
      )}
    </div >
  )
}

export default CardComponent
